import React, { useMemo } from 'react';
import PointerArrow from '../PointerArrow';

/**
 * AddMissionArrow Component
 * 
 * A specialized PointerArrow that automatically finds and points at
 * the "Mission" button in the toolbar. Used for onboarding empty states.
 * 
 * This is a convenience wrapper around PointerArrow that handles
 * the logic of finding the Mission button across different views.
 */
const AddMissionArrow = ({ isVisible, onDismiss }) => {
  // Find the actual target element
  const targetElement = useMemo(() => {
    if (!isVisible) return null;
    
    // Try accent variant first (Flow/Table views)
    const accentButtons = document.querySelectorAll('.toolbar-btn--accent');
    for (const btn of accentButtons) {
      const label = btn.querySelector('.toolbar-btn__label');
      if (label && label.textContent === 'Add Mission') {
        return btn;
      }
    }
    
    // Try primary variant (Todo view)
    const primaryButtons = document.querySelectorAll('.toolbar-btn--primary');
    for (const btn of primaryButtons) {
      const label = btn.querySelector('.toolbar-btn__label');
      if (label && label.textContent === 'Add Mission') {
        return btn;
      }
    }
    
    // Fallback: look for any button with "Add Mission" label in toolbar
    const allToolbarButtons = document.querySelectorAll('.toolbar-btn');
    for (const btn of allToolbarButtons) {
      const label = btn.querySelector('.toolbar-btn__label');
      if (label && label.textContent === 'Add Mission') {
        return btn;
      }
    }
    
    return null;
  }, [isVisible]);

  return (
    <PointerArrow
      isVisible={isVisible}
      onDismiss={onDismiss}
      label="Click here to add a mission"
      direction="up"
      targetElement={targetElement}
      variant="primary"
    />
  );
};

export default AddMissionArrow;
